/** Default ARIA label strings used as fallback prop defaults across close-button primitives -- SSOT so a future i18n migration routes through one lookup. */

export const DEFAULT_CLOSE_LABEL = 'Close' as const;

/** Names the shared page-template view switcher's toolbar. `ViewToggle` requires a name for its grouping role, and this row is the generic one every list page renders. */
export const VIEW_MODE_TOOLBAR_LABEL = 'View mode' as const;

/**
 * The accessible name of a LIST-ROW selection checkbox, whose only visible context is the row it sits in -- so the
 * row's own display text is the name, and the verb has to be supplied. A function rather than a scalar because the
 * decision is the SHAPE (`Select <row>`), not one string: the admin transactions and properties list cards each
 * spelled the template privately, differing only in how they resolve the row's display text.
 *
 * @runtime-derived-ssot-helper (const-leaf-pinned): the CONSTANT is the template `Select <row>` this leaf owns
 * alongside its sibling label scalars; only the row's display text is runtime, so the function is that constant's
 * derivation surface. Relocating it to `utils/` would put one member of a single label vocabulary on a different
 * floor from the rest, which is what let the two list pages spell it privately in the first place.
 */
export function selectRowAriaLabel(rowLabel: string): string {
	return `Select ${rowLabel}`;
}
